import { alpha, CSSObject, IconButton, styled } from '@mui/material';
import { common } from '@mui/material/colors';

import { AppLayout } from '@/dmdrive/core/constants/layout';

export const RightSidebarRoot = styled('div')(({ layout, isOpen }: { layout: AppLayout; isOpen: boolean }) => {
  let styles: CSSObject = {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: common.white,
    height: '100%',
    overflow: 'hidden',
  };

  if (layout === AppLayout.Desktop) {
    styles = {
      ...styles,
      width: '20rem',
      borderLeft: `0.1rem solid ${alpha(common.black, 0.12)}`,
    };
  }

  if (layout === AppLayout.Mobile) {
    styles = {
      ...styles,
      position: 'absolute',
      zIndex: 1000,
      width: '100%',
      left: '-100%',
    };

    if (isOpen) {
      styles.left = 0;
    }
  }

  return styles;
});

export const CloseRightSidebar = styled(IconButton)({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
});

export const RightSidebarContent = styled('div')({
  flexGrow: 1,
  overflow: 'hidden',
});
